module.exports = __webpack_public_path__ + "static/scale-model-of-johnson-springview-park-in-roseville-california-6f435a16b45086e8d94e8a7eb09b0147.png";